<template>
    <popup-confirmation 
        ref="form"
        title="期間指定"
        min-height="10rem"
        max-width="45rem"
        persistent
    >
        <template v-slot:description>
            <v-container class="py-0">
                <v-row v-if="!customOnly">
                    <v-col>
                        <v-radio-group
                        v-model="rangeType"
                        class="mt-0 pt-0"
                        row
                        hide-details
                        mandatory
                        >
                            <v-radio v-for="type in typeList"
                            row
                            :key="type.value"
                            :label="type.label"
                            :value="type.value"
                            />
                        </v-radio-group>
                    </v-col>
                </v-row>
                <template v-if="rangeType == 'month'">
                    <v-row align="center" justify="center">
                        <v-col cols="auto" class="px-0">
                            対象月
                        </v-col>
                        <v-col cols="auto">
                            <ui-month-picker
                                label="月指定"
                                hide-details
                                :min-date="minDate"
                                :max-date="maxDate"
                                v-model="directMonth"
                            />
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <span>
                                {{ monthStart }} ～ {{ monthEnd }}
                            </span>
                        </v-col>
                    </v-row>
                </template>
                <template v-else-if="rangeType == 'custom'">
                    <v-row align="center" justify="center">
                        <v-col cols="1" class="pl-0">
                            From
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <ui-date-picker
                                hide-details
                                :min-date="minDate"
                                :max-date="maxDate"
                                v-model="from_date"
                            />
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <ui-time-selector
                                :per-minute="1"
                                hide-details
                                v-model="from_time"
                            />
                        </v-col>
                        <v-col cols="1" class="pa-0">
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col  cols="1" class="pl-0">
                            To
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <ui-date-picker
                                hide-details
                                :min-date="minDate"
                                :max-date="maxDate"
                                v-model="to_date"
                            />
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <ui-time-selector
                                :per-minute="1"
                                hide-details
                                v-model="to_time"
                            />
                        </v-col>
                        <v-col cols="1" class="py-0">
                            <v-btn icon @click="resetTo">
                                <span class="primary--text">
                                    現在
                                </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <span v-if="isValidRange"
                                class="error--text text-caption">
                                {{ '日時は「From ＜= To」となるように指定してください' }} 
                            </span>
                            <span v-if="!withinMaxRange" class="error--text text-caption">
                                期間は最大{{ maxRangeText }}の範囲で指定してください
                            </span>
                        </v-col>
                    </v-row>
                </template>
            </v-container>
        </template>
        <template v-slot:actions>
            <v-row no-gutters>
                <v-col>
                    <v-btn block color="disabledBack" @click="close()">キャンセル</v-btn>
                </v-col>
                <v-col>
                    <v-btn block color="primary" :disabled="disableSave" @click="save()">確定</v-btn>
                </v-col>
            </v-row>
        </template>
    </popup-confirmation>
</template>

<script>
export default {
    name: 'ui-popup-timerange-selector',
    model: {
        prop: 'range'
    },
    props:{
        range: {
            type: Object
        },
        minDate: {
            type: String,
            default: ''
		},
        maxDate: {
            type: String,
            default: ''
		},
		maxRange: {
			type: String,
			default: '',
			validator: function (value) {
				/**
				 * string(y or m or d) + int(>0)
				 * 'y1','m3','d45', etc.
				 */
                return value.length === 0 || /^[ymd][1-9][0-9]*$/.test(value);
			},
        },
        customOnly: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            from_date: '',
            from_time: '',
            to_date: '',
            to_time: '',
            directMonth: '',
            rangeType: this.customOnly ? 'custom' : 'month',
            typeList: [
                {
                    label: '月を指定',
                    value: 'month',
                }, {
                    label: '範囲を指定',
                    value: 'custom',
                },
            ],
        }
    },
    computed: {
        isValidRange: function() {
            return !this.$timeutil.isLaterLeftTime(this.to_date + this.to_time, this.from_date + this.from_time);
        },
        tmpRange: {
            get () {
                return this.range;
            },
            set (val) {
                this.$emit('input', val)
            }
        },
		withinMaxRange: function () {
			if (!this.maxRange) return true;
			if (!this.$validator.isFormatDate(this.from_date) || !this.$validator.isFormatDate(this.to_date)
			|| !this.$validator.isFormatTime(this.from_time) || !this.$validator.isFormatTime(this.to_time)
			) return false;
			return this.$validator.isWithinMaxRange(this.from_date + ' ' + this.from_time, this.to_date + ' ' + this.to_time, this.maxRange);
		},
		maxRangeText: function () {
			let ret = this.maxRange.substr(1);
			switch (this.maxRange.substr(0, 1)) {
				case 'y':
					ret += '年';
					break;
				case 'm':
					ret += 'ヶ月';
					break;
				case 'd':
					ret += '日';
					break;
			}
			return ret;
		},
		disableSave: function () {
			return this.isValidRange || !this.withinMaxRange;
		},
        monthStart: function(){
            return this.$timeutil.getFirstDatetimeOfMonth(this.directMonth);
        },
        monthEnd: function(){
			const lastDay = this.$timeutil.getLastDatetimeOfMonth(this.directMonth);
            console.log(this.maxDate);
				if (this.$timeutil.isLaterLeftTime(lastDay, this.maxDate)) {
					return this.$timeutil.strTimeFormat(this.maxDate);
				} else {
					return lastDay;
				}
        }
    },
    methods: {
        open(){
            this.$refs.form.open();
            let from = !!this.tmpRange.datetime_start ? this.tmpRange.datetime_start.split(' ') : ['', ''];
            let to = !!this.tmpRange.datetime_end ? this.tmpRange.datetime_end.split(' ') : ['', ''];
            this.from_date = from[0]
            this.from_time = from[1]
            this.to_date = to[0]
            this.to_time = to[1]
        },
        save(){
            if (this.rangeType == 'custom') {
                this.tmpRange.datetime_start = this.from_date + ' ' + this.from_time;
                this.tmpRange.datetime_end   = this.to_date + ' ' + this.to_time;
            } else if (this.rangeType == 'month') {
                this.tmpRange.datetime_start = this.monthStart;
                this.tmpRange.datetime_end   = this.monthEnd;
            }
            this.$emit('change-range');
            this.close();
        },
        close(){
            this.$refs.form.close();
        },
        resetTo(){
            let f = this.$timeutil.getNowDatetime().split(' ');
            this.to_date = f[0];
            this.to_time = f[1];
        },
        resetFrom(){
            let f = this.$timeutil.getNowDatetime().split(' ');
            this.from_date = f[0];
            this.from_time = f[1];
        }
    }
}
</script>